import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import DatePickerDemo from './DatePickerDemo';
import DateRangePickerDemo from './DateRangePickerDemo';

const DatePickers = () => (
	<React.Fragment>
		<ContentHeader title="DatePicker" description="Different forms of datepickers">
		</ContentHeader>
		<ContentBody>
			<Row>
				<Col md={6}>
					<DatePickerDemo />
				</Col>
				<Col md={6}>
					<DateRangePickerDemo />
				</Col>
			</Row>
		</ContentBody>
	</React.Fragment>
)

export default DatePickers;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/DatePickers/index.js